(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pw-m0700-faq"] && !Shopify.designMode) return;
  try {
    (() => {
 'use strict';
 const root=document.querySelector('[data-pw-faq]');
 if(!root) return;
 const tabs=[...root.querySelectorAll('.pw-faq__tab')];
 const panels=[...root.querySelectorAll('.pw-faq__panel')];
 const tablist=root.querySelector('.pw-faq__nav');
 if(!tabs.length || tabs.length!==panels.length) return;
 const mobile=window.matchMedia('(max-width:768px)');
 tablist.setAttribute('role','tablist');
 const orient=()=>tablist.setAttribute('aria-orientation',mobile.matches?'horizontal':'vertical');
 orient(); mobile.addEventListener('change',orient);
 tabs.forEach(tab=>{
   tab.setAttribute('role','tab');
   tab.setAttribute('aria-controls','pw-panel-'+tab.dataset.panel);
 });
 panels.forEach(panel=>{
   panel.setAttribute('role','tabpanel');
   panel.setAttribute('aria-labelledby','pw-tab-'+panel.dataset.category);
 });
 const supportCopy={
   care:['Need help with your camera?','Have your order number and model ready, and share photos or a short video of the issue.','Contact Powerwill Support'],
   orders:['Need help with your order?','Have your order number and checkout email ready, and tell us what happened.','Contact Powerwill Support']
 };
 const support=root.querySelector('.pw-faq__support');
 const supportDefault=['Not sure this camera fits your job?','Tell us the height, viewing angle, destination ZIP and planned inspection date.','Ask Powerwill Support'];
 function select(index,focus=false,slide=false){
  tabs.forEach((tab,i)=>{
    const active=i===index;
    tab.setAttribute('aria-selected',String(active));
    tab.tabIndex=active?0:-1;
    panels[i].hidden=!active;
    panels[i].tabIndex=active?0:-1;
  });
  if(support){
    const copy=supportCopy[tabs[index].dataset.panel] || supportDefault;
    support.querySelector('h3').textContent=copy[0];
    support.querySelector('p').textContent=copy[1];
    support.querySelector('a').textContent=copy[2];
  }
  if(focus) tabs[index].focus({preventScroll:true});
  if(slide && mobile.matches){
    const left=tablist.scrollLeft+tabs[index].getBoundingClientRect().left-tablist.getBoundingClientRect().left;
    tablist.scrollTo({left,behavior:"smooth"});
  }
 }
 tabs.forEach((tab,i)=>{
   tab.addEventListener('click',()=>select(i,false,true));
   tab.addEventListener('keydown',event=>{
     let n=i;
     const next=mobile.matches?'ArrowRight':'ArrowDown';
     const prev=mobile.matches?'ArrowLeft':'ArrowUp';
     if(event.key===next) n=(i+1)%tabs.length;
     else if(event.key===prev) n=(i-1+tabs.length)%tabs.length;
     else if(event.key==='Home') n=0;
     else if(event.key==='End') n=tabs.length-1;
     else return;
     event.preventDefault(); select(n,true,true);
   });
 });
 let carouselTimer;
 tablist.addEventListener('scroll',()=>{
   if(!mobile.matches) return;
   clearTimeout(carouselTimer);
   carouselTimer=setTimeout(()=>{
     const left=tablist.getBoundingClientRect().left;
     let nearest=0; let distance=Infinity;
     tabs.forEach((tab,i)=>{
       const current=Math.abs(tab.getBoundingClientRect().left-left);
       if(current<distance){distance=current;nearest=i;}
     });
     select(nearest);
   },120);
 },{passive:true});
 // Keep at most one answer expanded within a category. Mobile starts with all answers closed.
 // On revisit, preserve the visitor's previous disclosure state rather than resetting it.
 root.querySelectorAll('details').forEach(detail=>detail.addEventListener('toggle',()=>{
   if(!detail.open) return;
   detail.closest('.pw-faq__panel').querySelectorAll('details[open]').forEach(other=>{
     if(other!==detail) other.open=false;
   });
 }));
 // Deep links open the intended question and its category. No network calls or analytics are included.
 function openHash(){
   let id; try { id=decodeURIComponent(location.hash.slice(1)); } catch { return false; }
   if(!id || !id.startsWith('pw-faq-')) return false;
   const target=document.getElementById(id);
   if(!target || !root.contains(target) || target.tagName!=='DETAILS') return false;
   const panel=target.closest('.pw-faq__panel');
   const index=panels.indexOf(panel); if(index<0) return false;
   select(index,false,true); target.open=true;
   return true;
 }

 root.classList.add('pw-faq--enhanced');
 if(mobile.matches) tablist.scrollLeft=0;
 select(0); openHash();
 window.addEventListener('hashchange',openHash);
})();
  } catch(e) { console.error(e); }
})();

})();
